import Plugin from '../index.js'
import axios from 'axios'
import gql from 'graphql-tag'

export default {
  upload(file, presignedPost, progressCallback) {
    const { form_attributes, form_inputs } = JSON.parse(presignedPost)

    // construct FormData for upload
    const formData = new FormData()

    for (let [k, v] of Object.entries(form_inputs)) {
      formData.append(k, v)
    }
    // we have to append the file last, because aws seams to ignore everything after it: https://stackoverflow.com/a/15235866
    formData.append('file', file)

    // we have to use a clean axios instance (otherwise there will be other headers, e.g. Authorization) which interferes with the upload
    const cleanAxios = axios.create()

    return cleanAxios({
      url: form_attributes.action, // Upload URL (S3)
      method: form_attributes.method, // normally POST
      headers: { 'content-type': form_attributes.enctype }, // normally multipart/form-data,
      data: formData,
      onUploadProgress: function (progressEvent) {
        const loaded = progressEvent.loaded
        const total = progressEvent.total
        const uploadPercent = (loaded / total) * 100

        // Save upload progress for this file
        if (typeof progressCallback === 'function') {
          progressCallback({
            event: progressEvent,
            percent: uploadPercent
          })
        }
      }
    })
  },

  /**
   * Uploads a file to s3 and finalizes it via a graphql mutation.
   *
   * @param {string} id The file ID
   * @param {File} file the file
   * @param {string} presignedPost the json which represents the presignedPost
   */
  uploadGraphQL(id, file, presignedPost) {
    return new Promise((resolve, reject) => {
      this.upload(file, presignedPost, null)
        .then(() => {
          return Plugin.$apollo.mutate({
            mutation: gql`
              mutation finalizeFile($id: ID!) {
                finalizeFile(id: $id) {
                  id
                  status
                }
              }
            `,
            variables: {
              id: id
            }
          })
        })
        .then(() => {
          resolve(id)
        })
        .catch((err) => reject(err))
    })
  },

  uploadFile(data, file) {
    if (data && !!data.presignedPost) {
      const presignedPost = data?.presignedPost ?? null

      if (presignedPost && file) {
        return this.uploadGraphQL(data.id, file, presignedPost)
      }
    }

    // we should not reach this
    return Promise.reject()
  },

  uploadFiles(dataFiles, dropzone) {
    const filesToUpload = dropzone
    const promises = []

    if (filesToUpload && filesToUpload.length > 0) {
      // loop through all files and start the upload
      const files = (dataFiles || []).filter((item) => !!item.presignedPost)
      for (let i = 0; i < files.length; i++) {
        const gqlData = files[i]
        const presignedPost = gqlData?.presignedPost ?? null
        const file = filesToUpload?.[i]?.file ?? null

        if (presignedPost && file) {
          promises.push(this.uploadGraphQL(gqlData.id, file, presignedPost))
        }
      }
    }

    return Promise.all(promises)
  }
}
